import { BaseApiService } from '@pascal/pascal-core/shared/core/services/api/BaseApiService';
import { ApiVersion, httpClient } from '@pascal/pascal-core';

export class BonusIslandService extends BaseApiService {
  constructor(config) {
    super(config);
  }

  async getBonusIslandData(params, options = { version: ApiVersion.v1 }) {
    const { version } = options;
    let url = `${this.url}/api/${version}/Tournament`;
    if (params) {
      url += `/${params}`;
    }
    return httpClient.get(url);
  }
}
